export default "__VITE_ASSET__DKOixYN1__"